import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import "@/index.css";
import App from "@/App";
import { LanguageProvider } from "@/contexts/LanguageContext";

const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <LanguageProvider>
          {recaptchaSiteKey ? (
            <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
              <App />
            </GoogleReCaptchaProvider>
          ) : (
            <App />
          )}
        </LanguageProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
